import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { Row, Col, Button, Label } from 'reactstrap'
import { InputText } from 'primereact/inputtext'
import { Button as ButtonPrime } from 'primereact/button'

import useGetStates from '../../../hooks/useGetStates'
import CustomSelect from '../../../common/CustomReactSelectComponent'
import Loader from '../../../modules/Loader/index'
import { CustomInputMask, CustomInputText } from '../../CustomInputs/CustomInputs'
import { findLesseeByMC, clearLessee, getContact } from '../../../modules/Contacts/redux/ContactActions'
import { closeModal } from '../../GlobalModal/redux/GlobalModalActions'
import { notificationDangerCustomTime, notificationSuccess } from '../../../utils/customToastify'

import { PROSPECT_SOURCE, NATIONALITY, ACCOUNT_SOURCE } from '../../../constants/supportTypes'

const ConvertContactLessee = () => {
  const dispatch = useDispatch()
  const stateOptions = useGetStates({ isAbbreviation: false })
  const { lessee, lesseeHasData, errors, contactId, divisionId, nationalityId } = useSelector((state) => {
    return {
      lessee: state.contacts.lessee,
      lesseeHasData: !!Object.keys(state.contacts.lessee.data).length,
      errors: state.errors,
      contactId: state.contacts.contact.id,
      nationalityId: state.contacts.contact.nationalityId,
      divisionId: state.auth.user.division_id,
    }
  })
  const [isLoading, setLoading] = useState(false)
  const [data, setData] = useState({
    nationalityId: nationalityId || null,
  })
  const [options, setOptions] = useState({
    ProspectSource: [],
    AccountSource: [],
    Nationality: [],
  })

  const [submitting, setSubmitting] = useState(false)

  useEffect(() => {
    // if (lesseeHasData) {
    const { name, addressStreet1, addressCity, addressZip, addressState, businessPhone, ownerName, id } = lessee.data
    setData({
      ...data,
      lessee: id || null,
      lesseeName: name || '',
      lesseeStreet: addressStreet1 || '',
      lesseeCity: addressCity || '',
      lesseeZip: addressZip || '',
      lesseeState: addressState || null,
      lesseePhone: businessPhone || '',
      lesseeOwnerName: ownerName || '',
    })
    // }
  }, [lessee.data])

  useEffect(() => {
    loadTypes()
    return () => {
      dispatch(clearLessee())
    }
  }, [])

  useEffect(() => {
    if (Object.keys(errors)?.length) {
      setSubmitting(false)
    }
  }, [errors])

  const loadTypes = async () => {
    const response = await axios.get(
      `/support-types/supportTypesForSelects/?types=${PROSPECT_SOURCE}&types=${NATIONALITY}&types=${ACCOUNT_SOURCE}`
    )
    let options = {}
    response.data.map((i) => {
      return (options[i.name.replace(/\s/g, '')] = i.data)
    })
    setOptions(options)
  }

  const handleChangeSelect = (value, e) => {
    setData({ ...data, [e.name]: value ? value.id || value.value : null })
  }

  const handleChangeInputs = (e) => {
    const { name, value } = e.target
    setData({ ...data, [name]: value })
  }

  const onLesseeSearch = async () => {
    if (!data.lesseeMC) {
      notificationDangerCustomTime('Please enter MC number to be able to search!', 10000)
      return
    }
    setLoading(true)
    await dispatch(findLesseeByMC(data.lesseeMC))
    setLoading(false)
  }

  const convertContact = async () => {
    try {
      setSubmitting(true)
      setLoading(true)
      await axios.post('/contacts/convertContact/lessee', { ...data, contactId, creationDate: new Date() })
      setLoading(false)
      dispatch(closeModal('converting_contacts_lessee'))
      notificationSuccess('⭐ Conversion successful ⭐')
      await dispatch(getContact(contactId, divisionId))
    } catch (e) {
      setSubmitting(false)
      setLoading(false)
    }
  }

  let loader = null
  if (isLoading) loader = <Loader />

  return (
    <>
      <Row>
        <Col>
          Are you sure you wish to <span className='font-weight-bold'>{`claim & convert`}</span> this Prospect to an{' '}
          <span className='font-weight-bold'>Account</span>?
        </Col>
      </Row>
      {loader}
      <Row className='mt-4'>
        <Col md='6'>
          <CustomSelect
            isMulti={false}
            label={'Account Source'}
            placeholder={'Account Source'}
            name='accountSource'
            onChange={handleChangeSelect}
            defaultValue={data.accountSource || 0}
            options={options.AccountSource}
            isClearable
            invalid={!!errors.accountSource}
            errorMess={errors.accountSource}
          />
        </Col>
        <Col md='6'>
          <CustomSelect
            isMulti={false}
            label='Preferred Language'
            placeholder='Select...'
            name='nationalityId'
            onChange={handleChangeSelect}
            defaultValue={data.nationalityId || 0}
            options={options.Nationality}
            isClearable
            invalid={!!errors.nationalityId}
            errorMess={errors.nationalityId}
          />
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col md='6'>
          <Label className='d-block mb-2'>Lessee MC</Label>
          <div className='p-inputgroup'>
            <InputText
              placeholder='Lessee MC'
              className='p-inputtext-sm'
              name='lesseeMC'
              value={data.lesseeMC}
              onChange={handleChangeInputs}
            />
            <ButtonPrime icon='pi pi-search' className='p-button-warning p-button-sm' onClick={onLesseeSearch} />
          </div>
          {errors.lesseeMC && <small className='text-danger d-block'>{errors.lesseeMC}</small>}
        </Col>
        <Col md='6'>
          <CustomInputText
            label='Lessee Name'
            value={data.lesseeName}
            onChange={handleChangeInputs}
            name={'lesseeName'}
            disabled={!lessee.isSearched || (lessee.isSearched && lesseeHasData)}
            placeholder={'Lessee Name'}
            errorMess={errors.lesseeName}
          />
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col md='6'>
          <CustomInputText
            label='Lessee Street'
            value={data.lesseeStreet}
            onChange={handleChangeInputs}
            name={'lesseeStreet'}
            disabled={!lessee.isSearched || (lessee.isSearched && lesseeHasData)}
            placeholder={'Lessee Street'}
            errorMess={errors.lesseeStreet}
          />
        </Col>
        <Col md='6'>
          <CustomInputText
            label='Lessee City'
            value={data.lesseeCity}
            onChange={handleChangeInputs}
            name={'lesseeCity'}
            disabled={!lessee.isSearched || (lessee.isSearched && lesseeHasData)}
            placeholder={'Lessee City'}
            errorMess={errors.lesseeCity}
          />
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col md='6'>
          <CustomInputText
            label='Lessee Zip'
            value={data.lesseeZip}
            onChange={handleChangeInputs}
            name={'lesseeZip'}
            disabled={!lessee.isSearched || (lessee.isSearched && lesseeHasData)}
            placeholder={'Lessee Zip'}
            errorMess={errors.lesseeZip}
          />
        </Col>
        <Col md='6'>
          <CustomSelect
            isMulti={false}
            label='Lessee State'
            placeholder='Lessee State'
            name='lesseeState'
            onChange={handleChangeSelect}
            defaultValue={data.lesseeState || 0}
            disabled={!lessee.isSearched || (lessee.isSearched && lesseeHasData)}
            options={stateOptions}
            isClearable
            invalid={!!errors.lesseeState}
            errorMess={errors.lesseeState}
          />
        </Col>
      </Row>
      <Row className='mt-2'>
        <Col md='6'>
          <CustomInputMask
            label='Lessee Phone'
            value={data.lesseePhone}
            onChange={handleChangeInputs}
            name={'lesseePhone'}
            disabled={!lessee.isSearched || (lessee.isSearched && lesseeHasData)}
            placeholder={'Lessee Phone'}
            errorMess={errors.lesseePhone}
          />
        </Col>
        <Col md='6'>
          <CustomInputText
            label='Lessee Owner'
            value={data.lesseeOwner}
            onChange={handleChangeInputs}
            name={'lesseeOwner'}
            disabled={!lessee.isSearched || (lessee.isSearched && lesseeHasData)}
            placeholder={'Lessee Owner'}
            errorMess={errors.lesseeOwner}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <hr />
        </Col>
      </Row>
      <Row className='d-flex justify-content-end pr-3'>
        <Button className='btn btn-sm btn-gold' onClick={convertContact} disabled={submitting}>
          Save
        </Button>
        <Button
          className='btn btn-sm btn-danger ml-2'
          onClick={() => dispatch(closeModal('converting_contacts_lessee'))}
        >
          Cancel
        </Button>
      </Row>
    </>
  )
}

export default ConvertContactLessee
